export const TRAVEL_SOURCE_OF_FUND_OPTIONS = [
  {
    value: "Ownership of a business/self-employed",
    label: "Ownership of a business/self-employed",
  },
  {
    value: "Employment/Salaried",
    label: "Employment/Salaried",
  },
  {
    value: "Inheritance",
    label: "Inheritance",
  },
  {
    value: "Investment",
    label: "Investment",
  },
] as const;

export const TRAVEL_BENEFICIARY_RELATION_OPTIONS = [
  { value: "Legal Heir", label: "Legal Heir" },
  { value: "Other", label: "Other" },
] as const;

export const TRAVEL_GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
] as const;

export function normalizeNationalityValue(ocrNationality: string): string {
  if (!ocrNationality) {
    return "";
  }

  const normalized = ocrNationality.trim().toLowerCase();
  const nationalityMap: Record<string, string> = {
    india: "India",
    indian: "India",
    uae: "United Arab Emirates",
    ae: "United Arab Emirates",
    "united arab emirates": "United Arab Emirates",
  };

  if (nationalityMap[normalized]) {
    return nationalityMap[normalized];
  }

  return normalized
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function getBirthYearFromEmiratesId(emiratesId: string): string | null {
  const match = /^784-(\d{4})-\d{7}-\d{1}$/.exec(emiratesId);
  return match ? match[1] : null;
}

export function getYearFromDob(dob: string): string | null {
  if (!dob) {
    return null;
  }

  const isoMatch = /^(\d{4})-\d{2}-\d{2}$/.exec(dob);
  if (isoMatch) {
    return isoMatch[1];
  }

  const dmyMatch = /^\d{2}-\d{2}-(\d{4})$/.exec(dob);
  return dmyMatch ? dmyMatch[1] : null;
}
